"use client";

import { Facebook, Instagram, Linkedin, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Input } from "@/components/ui/input";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        <div className="h-4 w-20 bg-muted/20 animate-pulse rounded" />
        <div className="h-3 w-16 bg-muted/20 animate-pulse rounded" />
        <div className="h-3 w-16 bg-muted/20 animate-pulse rounded" />
      </div>;
  }
  return <nav className="flex flex-col gap-3">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} data-index={i} className="text-sm text-dark-foreground transition-colors duration-150 !bg-transparent hover:text-primary">
          {item.label}
        </Link>)}
    </nav>;
}
function FooterContent() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <div ref={ref} className={`transition-all duration-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          <div>
            <h3 className="text-primary font-semibold mb-4">Legal</h3>
            <div className="flex flex-col gap-3">
              <Link to="/PrivacyPolicyPage" className="text-sm transition-colors duration-150 border-[rgb(36,99,235)] !border-solid !border-1 !text-[hsl(208,7%,46%)] hover:text-primary">Privacy Policy</Link>
              <Link to="/LegalDisclaimerPage" className="text-sm transition-colors duration-150 !bg-transparent !text-[hsl(208,7%,46%)] hover:text-primary">Legal Disclaimer</Link>
              <Link to="/CookiePolicyPage" className="text-sm transition-colors duration-150 !bg-transparent !text-[hsl(208,7%,46%)] hover:text-primary">
                Cookie Policy
              </Link>
            </div>
          </div>

          <div className="!opacity-[1] !text-[hsl(208,7%,46%)] !bg-transparent">
            <h3 className="text-primary font-semibold mb-4">Menu</h3>
            <MenuProvider menu_id="4">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          <div>
            <h3 className="text-primary font-semibold mb-4">Sloane &amp; Co. LLP</h3>
            <div className="flex flex-col gap-3">
                <div className="flex items-start gap-2">
                <span className="text-primary text-xs mt-1">•</span>
                <p className="text-sm !text-[hsl(208,7%,46%)]">Registered in England &amp; Wales.&nbsp;</p>
              </div>
              <div className="flex items-start gap-2 !text-[hsl(208,7%,46%)]">
                <span className="text-primary text-xs mt-1">•</span>
                <p className="text-sm !text-[hsl(208,7%,46%)]">Reg No. OC314505</p>
              </div>
              <div className="flex items-start gap-2">
                <span className="text-primary text-xs mt-1">•</span>
                <p className="text-sm !text-[hsl(208,7%,46%)]">Association of Chartered Certified Accountants</p>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-primary font-semibold mb-4">Connect</h3>
            <div className="flex gap-4">
              <Link to="https://www.instagram.com/sloanecollp/" newTab className="text-primary hover:text-accent-dark transition-colors duration-150" aria-label="Instagram">
                <Instagram className="size-5" />
              </Link>
              <Link to="https://www.linkedin.com/company/sloane-&-co" newTab className="text-primary hover:text-accent-dark transition-colors duration-150" aria-label="LinkedIn">
                <Linkedin className="size-5" />
              </Link>
              <Link to="https://facebook.com" newTab className="text-primary hover:text-accent-dark transition-colors duration-150" aria-label="Facebook">
                <Facebook className="size-5" />
              </Link>
            </div>
            <div className="mt-6">
              <img src="https://grown-elk-1.10web.cloud/wp-content/uploads/2026/02/acca.gif" alt="Sloane Accreditation" className="h-7" />
            </div>
          </div>
        </div>

        <Separator className="my-8 bg-dark-foreground/10" />

        <div className="pb-8 text-center">
          <p className="text-sm text-foreground">
            &copy; {new Date().getFullYear()} Sloane. All rights reserved.
          </p>
        </div>
      </div>
    </div>;
}
export default function Footer() {
  return <footer id="footer" className="dark bg-background text-foreground py-16">
      <FooterContent />
    </footer>;
}